import { object_ref_id } from './world_medals';

// Worlds that belong to any pack: they are premium and OUT of the star chain.
export const premium_world_ids = (packs) => {
	const ids = new Set();
	(packs ?? []).forEach((pack) => {
		(pack.worlds ?? []).forEach((world) => {
			const ref = object_ref_id(world);
			if (ref) ids.add(ref);
		});
	});
	return ids;
};

// Recipes sold inside any pack (premium recipes inside free worlds).
export const pack_recipe_ids = (packs) => {
	const ids = new Set();
	(packs ?? []).forEach((pack) => {
		(pack.recipes ?? []).forEach((recipe) => {
			const ref = object_ref_id(recipe);
			if (ref) ids.add(ref);
		});
	});
	return ids;
};

export const recipes_count_by_world = (recipes) => {
	return (recipes ?? []).reduce((acc, recipe) => {
		const ref = object_ref_id(recipe.world);
		if (ref) acc[ref] = (acc[ref] ?? 0) + 1;
		return acc;
	}, {});
};

// FREE recipes per FREE world: excludes premium worlds entirely and
// pack-listed recipes inside free worlds — the star chain's real currency.
export const free_recipes_count_by_world = (recipes, packs) => {
	const premiumWorlds = premium_world_ids(packs);
	const premiumRecipes = pack_recipe_ids(packs);

	return (recipes ?? []).reduce((acc, recipe) => {
		const worldRef = object_ref_id(recipe.world);
		const recipeRef = object_ref_id(recipe._id);
		if (!worldRef || premiumWorlds.has(worldRef)) return acc;
		if (recipeRef && premiumRecipes.has(recipeRef)) return acc;
		acc[worldRef] = (acc[worldRef] ?? 0) + 1;
		return acc;
	}, {});
};

// Validates the star-goal chain over a given map order (array order = map
// order). Premium worlds are flagged 'premium' and skipped by the chain
// math. Free worlds get 'ok' | 'warn' (not increasing) | 'error'
// (unreachable with free recipes).
export const star_goal_flags = (orderedWorlds, recipes, packs) => {
	const premiumWorlds = premium_world_ids(packs);
	const freeCounts = free_recipes_count_by_world(recipes, packs);

	const flags = {};
	let achievable = 0;
	let prevGoal = 0;
	let chainIndex = 0;

	(orderedWorlds ?? []).forEach((world) => {
		const id = object_ref_id(world._id);

		if (premiumWorlds.has(id)) {
			flags[id] = 'premium';
			return;
		}

		const goal = world.star_goal ?? 0;

		if (chainIndex === 0) flags[id] = goal === 0 ? 'ok' : 'warn';
		else if (goal > achievable) flags[id] = 'error';
		else if (goal <= prevGoal) flags[id] = 'warn';
		else flags[id] = 'ok';

		prevGoal = goal;
		achievable += (freeCounts[id] ?? 0) * 5;
		chainIndex += 1;
	});

	return flags;
};
